import _ from 'underscore';
import { Analytics } from '@trello/atlassian-analytics';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { BoardCleanUpView } from 'app/scripts/views/board/BoardCleanUpView';
import { Auth } from 'app/scripts/db/auth';
import { l } from 'app/scripts/lib/localize';
import headerTemplate from 'app/scripts/views/templates/board_header';
import { InspiringBoardsWorkspaceIds } from 'app/scripts/data/inspiring-boards-workspace-ids';
import {
  featureFlagClient,
  seesVersionedVariation,
} from '@trello/feature-flag-client';
const isDesktop = require('@trello/browser').isDesktop();
import Dialog from 'app/scripts/views/lib/dialog';
import React from 'react';
import ReactDOM from '@trello/react-dom-wrapper';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { BoardViewsButton } from 'app/src/components/BoardViewsButton';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary/ErrorBoundary';
import { TimelineViewWrapper } from 'app/src/components/TimelineViewWrapper';
import { SingleBoardCalendarView } from 'app/src/components/BoardCalendarView';
import { Controller } from 'app/scripts/controller';
import { AutomaticReports } from 'app/src/components/Butler';
import { navigate } from 'app/scripts/controller/navigate';
import { sendPluginTrackEvent } from 'app/scripts/lib/plugins/plugin-behavioral-analytics';
import { WindowSize } from 'app/scripts/lib/window-size';
import { ButlerBoardButtons } from 'app/src/components/Butler/Buttons/ButlerBoardButtons';
import { PremiumFeature } from '@trello/product-features';
import { BoardHeaderTestIds } from '@trello/test-ids';
import { canViewTeamTablePage } from 'app/src/components/ViewsGenerics/canViewTeamTablePage';
import { pluginRunner } from 'app/scripts/views/internal/plugins/PluginRunner';
import { LazyViewSwitcher as ViewSwitcher } from 'app/src/components/ViewSwitcher';

// icons for board views switcher
import { CalendarIcon } from '@trello/nachos/icons/calendar';

import { TimelineIcon } from '@trello/nachos/icons/timeline';
import { LocationIcon } from '@trello/nachos/icons/location';
import { ListIcon } from '@trello/nachos/icons/list';
import { DashboardIcon } from '@trello/nachos/icons/dashboard';
import { TableIcon } from '@trello/nachos/icons/table';
import { sendErrorEvent } from '@trello/error-reporting';
import { Null } from 'app/src/components/Null';
import { logoDomain, mapPowerUpId as MAP_POWER_UP_ID } from '@trello/config';
import { SingleBoardTableView } from 'app/src/components/BoardTableView/SingleBoardTableView';
import { SingleBoardViewFilterPopoverButtonContainer } from 'app/src/components/FilterPopover';
import { filteredCardsCountState } from 'app/src/components/FilterPopover/filteredCardsCountState';
import { LazyBoardShareSpotlight as BoardShareSpotlight } from 'app/src/components/BoardShareButton';

export const renderBoardHeader = function () {
  const isPremOrgAdmin = this.model.isPremOrgAdmin(Auth.me());

  const data = {
    name: this.model.get('name'),
    canRename: isPremOrgAdmin || this.model.owned(),
    isLoggedIn: Auth.isLoggedIn(),
    isAdmin: this.model.ownedByMember(Auth.me()),
    isMember: this.model.isMember(Auth.me()),
    isPrivateTeam:
      this.model.hasOrganization() && !this.model.getOrganization(),
    isPrivateTeamForEnterpriseVisibleBoard:
      this.model.hasOrganization() &&
      this.model.getPref('permissionLevel') === 'enterprise',
    isUntitled: this.model.get('name') === l(['untitled board']),
    canJoin: this.model.canJoin(),
    canInviteMembers: this.model.canInviteMembers(),
    canAssign: this.model.editable(),
    isTemplate: this.model.isTemplate(),
    hasEditPrivileges: this.model.editable(),
    shareRenameEnabled: featureFlagClient.get(
      'smoothie.board-invite-popover',
      false,
    ),
    newSwitcherEnabled: seesVersionedVariation(
      'panorama.view-switcher',
      'alpha',
    ),
  };

  data.starTooltipKey = this.model.isTemplate()
    ? 'click-to-star-or-unstar-this-template-starred-templates-show-up-at-the-top-of-your-boards-list'
    : 'click-to-star-or-unstar-this-board-starred-boards-show-up-at-the-top-of-your-boards-list';

  const organization = this.model.getOrganization();
  if (organization) {
    data.orgDisplayName = organization.get('displayName');
    data.orgName = organization.get('name');
    data.showCopyButton = _.contains(
      InspiringBoardsWorkspaceIds,
      organization.id,
    );
    const _hash = organization.get('logoHash');
    const enterprise_hash = organization.getEnterprise()?.get('logoHash');
    if (enterprise_hash) {
      data.orgLogoUrl = `${logoDomain}/${enterprise_hash}/30.png`;
      data.orgLogoUrl2x = `${logoDomain}/${enterprise_hash}/170.png`;
    } else if (_hash) {
      data.orgLogoUrl = `${logoDomain}/${_hash}/30.png`;
      data.orgLogoUrl2x = `${logoDomain}/${_hash}/170.png`;
    }

    data.isStandard = organization.isStandard();
    data.isBusinessClass = organization.isBusinessClass();
    data.isRetiredBusinessClass = organization.isRetiredBusinessClass();
    data.isEnterprise = organization.get('idEnterprise');
  }

  // Work-around to avoid data loss from re-populating header and
  // over-writing filtering react component
  const britaReactRoot = this.el.querySelector(
    '.js-brita-board-filter-btn-container',
  );

  this.$('.js-board-header').html(headerTemplate(data));

  const newBritaReactRoot = this.el.querySelector(
    '.js-brita-board-filter-btn-container',
  );

  if (britaReactRoot) {
    newBritaReactRoot.parentNode.replaceChild(
      britaReactRoot,
      newBritaReactRoot,
    );
  }

  if (
    featureFlagClient.get('smoothie.board-invite-popover', false) &&
    featureFlagClient.get('smoothie.board-share-spotlight', false)
  ) {
    this.renderBoardShareButton();
  }

  this.renderBritaBoardFilterButton();
  this.renderPermissionLevel();
  this.renderBoardHeaderCalendar();
  this.renderBoardHeaderSubscribed();
  this.renderBoardHeaderMap();
  this.renderFilteringStatus();
  this.renderBoardHeaderStarred();
  this.renderPluginButtons();
  this.renderButlerBoardButtons();
  this.renderBoardHeaderFacepile();
  this.renderBoardTemplateBadge();
  this.renderWorkspacesAutoNameAlert();

  if (featureFlagClient.get('ecosystem.pup-header-cleanup', false)) {
    this.renderPluginDropdownList();
    this.renderPluginHeaderButtons();
  }

  this.renderBoardViewsButton();
  this.loadPowerUpViewsButtonOptions();

  return this;
};

export const renderBoardHeaderStarred = function () {
  if (this.model.isStarred()) {
    this.$('.js-star-board > .board-header-btn-icon').removeClass('icon-star');
    this.$('.js-star-board > .board-header-btn-icon').addClass('icon-starred');
  } else {
    this.$('.js-star-board > .board-header-btn-icon').removeClass(
      'icon-starred',
    );
    this.$('.js-star-board > .board-header-btn-icon').addClass('icon-star');
  }
  return this;
};

// always show hollow star on hover
export const hoverStar = function () {
  this.$('.js-star-board > .board-header-btn-icon').removeClass('icon-starred');
  this.$('.js-star-board > .board-header-btn-icon').addClass('icon-star');
};

// active state when clicking on state (onmousedown)
export const clickStar = function () {
  if (this.model.isStarred()) {
    this.$('.js-star-board > .board-header-btn-icon').removeClass(
      'icon-starred',
    );
    this.$('.js-star-board > .board-header-btn-icon').addClass('icon-star');
  } else {
    this.$('.js-star-board > .board-header-btn-icon').removeClass('icon-star');
    this.$('.js-star-board > .board-header-btn-icon').addClass('icon-starred');
  }
  return this;
};

export const toggleStarred = function () {
  const { boardStarList } = Auth.me();
  const boardStar = boardStarList.getBoardStar(this.model.id);
  if (boardStar) {
    boardStarList.unstarBoard(this.model.id);
  } else {
    boardStarList.starBoard(this.model.id);
  }

  Analytics.sendUpdatedBoardFieldEvent({
    field: 'star',
    value: !!boardStar,
    source: 'boardScreen',
    containers: {
      board: {
        id: this.model.id,
      },
    },
  });

  return this;
};

export const clearFilters = function (e) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'clearBoardFilterButton',
    source: 'boardScreen',
    containers: {
      board: {
        id: this.model.id,
      },
      organization: {
        id: this.model.getOrganization()?.id,
      },
      enterprise: {
        id: this.model.getEnterprise()?.id,
      },
    },
  });

  this.model.filter.clear();
};

export const showCleanUp = function (e) {
  stopPropagationAndPreventDefault(e);

  const view = new BoardCleanUpView({
    model: this.model,
    modelCache: this.modelCache,
  });
  Dialog.show({
    view,
    maxWidth: 800,
    hide() {
      return view.abort();
    },
  });
};

export const renderBoardShareButton = function () {
  const node = this.el.querySelector('.board-share-button');
  if (node) {
    renderComponent(
      <BoardShareSpotlight
        idBoard={this.model.id}
        idOrg={this.model.getOrganization()?.id}
      />,
      node,
    );
  }
};

export const removeBoardShareButton = function () {
  if (this.$('.board-share-button').length) {
    return ReactDOM.unmountComponentAtNode(this.$('.board-share-button')[0]);
  }
};

export const renderBritaBoardFilterButton = function () {
  const targetNodeForButton = this.el.querySelector(
    '.js-brita-board-filter-btn-container',
  );

  if (!targetNodeForButton) {
    return;
  }
  const isDateBasedView =
    Controller.showingCalendarView() || Controller.showingTimeline();

  const appearance =
    this.model.getPref('backgroundBrightness') === 'dark'
      ? 'transparent'
      : 'transparent-dark';

  renderComponent(
    <SingleBoardViewFilterPopoverButtonContainer
      idBoard={this.model.id}
      appearance={appearance}
      isDateBasedView={isDateBasedView}
    />,
    targetNodeForButton,
  );
};

export const renderBoardViewsButton = function () {
  const targetNodeForOldButton = this.el.querySelector(
    '.js-board-views-btn-container',
  );

  const targetNodeForSwitcherInHeader = this.el.querySelector(
    '.js-board-views-switcher',
  );
  const newSwitcherEnabled = seesVersionedVariation(
    'panorama.view-switcher',
    'alpha',
  );

  if (!newSwitcherEnabled) {
    if (!targetNodeForOldButton) {
      return;
    }

    const renderBoardViewsButtonWithReact = async () => {
      const me = Auth.me();

      let orgName = undefined;
      let idOrg = undefined;

      let hasTeamTable = false;
      let isOrgPrivate = undefined;
      let isTeamMember = false;
      let hasViewsFeature = false;
      let paidStatus;

      let isPublicTeamGuest = undefined;
      let isStandardOrFreeTeamBoardGuest = undefined;

      if (this.model.hasOrganization()) {
        idOrg = this.model.get('idOrganization');
        const org = this.model.getOrganization();

        // checks to disables board switcher button for standard and free board guests
        const isStandardOrFreeTeamBoard =
          !this.model.isEnterpriseBoard() && !this.model.isBcBoard();
        isPublicTeamGuest = this.model.isGuest(me);
        isStandardOrFreeTeamBoardGuest =
          isPublicTeamGuest && isStandardOrFreeTeamBoard;

        if (org) {
          orgName = org.get('name');
          isTeamMember = Boolean(org.isMember(me));
          hasViewsFeature = org.isFeatureEnabled(PremiumFeature.Views);
          hasTeamTable = canViewTeamTablePage(
            hasViewsFeature,
            org.isBusinessClass() || org.isEnterprise(),
          );
          paidStatus = org.getPaidStatus();
        } else {
          isOrgPrivate = true;
        }
      }

      renderComponent(
        <ErrorBoundary
          tags={{
            ownershipArea: 'trello-panorama',
            feature: 'Board Views Switcher',
          }}
          errorHandlerComponent={Null}
        >
          <BoardViewsButton
            isTeamMember={isTeamMember}
            orgName={orgName}
            idOrg={idOrg}
            isOrgPrivate={isOrgPrivate}
            paidStatus={paidStatus}
            isStandardOrFreeTeamBoardGuest={isStandardOrFreeTeamBoardGuest}
            hasViewsFeature={hasViewsFeature}
            shouldShowTeamTableLink={hasTeamTable}
            idBoard={this.model.id}
            oneTimeMessagesDismissed={me.attributes.oneTimeMessagesDismissed}
            shortLink={this.model.get('shortLink')}
            // eslint-disable-next-line react/jsx-no-bind
            preloadPlugins={() => {
              return this.model.getAvailablePlugins();
            }}
            viewOptions={this.getBoardViewsButtonOptions()}
            // eslint-disable-next-line react/jsx-no-bind
            clearFilters={() => this.model.filter.clear()}
            backgroundBrightness={this.model.getPref('backgroundBrightness')}
            isLoadingPowerUpViews={this.isLoadingPowerUpViews}
            powerUpViewOptions={this.getPowerUpViewOptions()}
            // eslint-disable-next-line react/jsx-no-bind
            setIframePopoverOverlayVisibility={(visibility) => {
              this.$('.js-plugin-iframe-container').toggleClass(
                'plugin-iframe-container-pop-over-shown',
                visibility,
              );
            }}
          />
        </ErrorBoundary>,
        targetNodeForOldButton,
      );
    };

    if (!this.boardViewsButtonPreviouslyRender) {
      // Defer here since the target div that is being rendered by Backbone may
      // not be available yet.
      _.defer(() => {
        renderBoardViewsButtonWithReact();
        return (this.boardViewsButtonPreviouslyRender = true);
      });
    } else {
      renderBoardViewsButtonWithReact();
    }
  } else {
    if (!targetNodeForSwitcherInHeader) {
      return;
    } else {
      renderComponent(
        <ErrorBoundary
          tags={{
            ownershipArea: 'trello-panorama',
            feature: 'View Switcher',
          }}
          errorHandlerComponent={Null}
        >
          <ViewSwitcher idBoard={this.model.id} />
        </ErrorBoundary>,
        targetNodeForSwitcherInHeader,
      );
    }
  }
};

// returns an array of view options, which are passed into the BoardViewButtons component
export const getBoardViewsButtonOptions = function () {
  const enterprise = this.model.getEnterprise();
  const me = Auth.me();
  const boardViewableBy = this.model.getViewPermState(me) !== 'none';
  const hasReachedPowerUpLimit = !this.model.canEnableAdditionalPowerUps();
  const boardEditable = this.model.editable();
  const isPrivateTeam =
    this.model.hasOrganization() && !this.model.getOrganization();
  const isPublicTeamGuest =
    this.model.hasOrganization() &&
    this.model.getOrganization() &&
    !this.model.getOrganization().isMember(me);
  const isBoardGuest = isPrivateTeam || isPublicTeamGuest;
  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  // used to determine if the Calendar or Map view option should appear.
  // If the pup is enabled, we show the options if you're a member or the board is public.
  // If the pup is not enabled, we still show the options, unless:
  //   - the pup is enterprise-disallowed
  //   - you can't enable more pups on this board and we are not upselling to you
  //   - you can view the board but not edit it

  // see https://hello.atlassian.net/wiki/spaces/TRELLO/pages/677256084/
  const shouldShowPupOption = ({ isPowerUpEnabled, isPowerUpAllowed }) => {
    if (!isPowerUpEnabled) {
      if (!isPowerUpAllowed) {
        return false;
      }

      if (hasReachedPowerUpLimit && boardEditable) {
        //Board Guests have no way to upgrade team, nor enable extra pups
        if (isBoardGuest) {
          return false;
        } else return !isDesktop;
      }

      if (boardViewableBy) {
        return boardEditable;
      }
    }
    return boardEditable || boardViewableBy;
  };

  // used to navigate to Calendar and Map's respective board routes.
  // but only if the pup is either successfully enabled first, or already enabled.
  const enablePupThenNavigate = (idPlugin, name) => {
    const pluginAttributes = {
      pluginName: name,
      pluginId: idPlugin,
      pluginTags: this.model.get('tags'),
    };
    const powerUpBoardUrl = Controller.getBoardUrl(this.model.id, name);
    if (this.model.isPluginEnabled(idPlugin)) {
      navigate(powerUpBoardUrl, { trigger: true });
    } else if (this.model.editable()) {
      const isPowerUpAllowed = enterprise
        ? enterprise.isPluginAllowed(idPlugin)
        : true;
      if (!isPowerUpAllowed) {
        return;
      }

      const traceId = Analytics.startTask({
        taskName: 'enable-plugin',
        source: 'boardViewsInlineDialog',
        attributes: pluginAttributes,
      });
      this.model.enablePluginWithTracing(idPlugin, {
        traceId,
        attributes: pluginAttributes,
        taskName: 'enable-plugin',
        source: 'boardViewsInlineDialog',
        next: (err) => {
          if (!err) {
            sendPluginTrackEvent({
              idPlugin,
              idBoard: this.model.id,
              event: {
                action: 'added',
                actionSubject: 'powerUp',
                source: 'boardViewsInlineDialog',
                attributes: {
                  tags: this.model.get('tags'),
                  taskId: traceId,
                },
              },
            });
            navigate(powerUpBoardUrl, { trigger: true });
          }
        },
      });
    }
  };

  const trackOptionClick = (actionSubjectId) => {
    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'dropdownItem',
      actionSubjectId,
      source: 'boardViewsInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
        enterprise: {
          id: this.model.getEnterprise()?.id,
        },
      },
    });
  };

  const boardOption = {
    name: 'board',
    descriptionString: 'board-view-description',
    icon: ListIcon,
    navigateTo: () => {
      const boardUrl = Controller.getBoardUrl(this.model.id);
      navigate(boardUrl, { trigger: true });

      // When maneuvering back to Board, we need to check again
      // for filters when updating the URL
      const queryString = this.model.filter.toQueryString();

      if (queryString) {
        return history.replaceState(null, null, boardUrl + queryString);
      }
    },
    track: () => trackOptionClick('boardViewDropdownItem'),
    isVisible: true,
    isGA: true,
    testId: BoardHeaderTestIds.BoardViewOption,
  };

  const mapOption = {
    name: 'map',
    descriptionString: 'map-view-description',
    icon: LocationIcon,
    showUpsell:
      !this.model.canEnableAdditionalPowerUps() &&
      !this.model.isPluginEnabled(MAP_POWER_UP_ID) &&
      !isDesktop,
    navigateTo: () => enablePupThenNavigate(MAP_POWER_UP_ID, 'map'),
    track: () => trackOptionClick('mapViewDropdownItem'),
    isVisible:
      hasViewsFeature &&
      shouldShowPupOption({
        isPowerUpEnabled: this.model.isPluginEnabled(MAP_POWER_UP_ID),
        isPowerUpAllowed: enterprise
          ? enterprise.isPluginAllowed(MAP_POWER_UP_ID)
          : true,
      }),
    isGA: true,
    testId: BoardHeaderTestIds.MapViewOption,
  };

  const timelineOption = {
    name: 'timeline',
    descriptionString: 'timeline-view-description',
    icon: TimelineIcon,
    navigateTo: () => {
      const timelineUrl = Controller.getBoardUrl(this.model.id, 'timeline');
      navigate(timelineUrl, { trigger: true });
    },
    track: () => trackOptionClick('timelineViewDropdownItem'),
    isVisible: hasViewsFeature,
    testId: BoardHeaderTestIds.TimelineViewOption,
  };

  const calendarViewOption = {
    name: 'calendar-view',
    descriptionString: 'calendar-view-description',
    icon: CalendarIcon,
    navigateTo: () => {
      const calendarViewUrl = Controller.getBoardUrl(
        this.model.id,
        'calendar-view',
      );
      navigate(calendarViewUrl, { trigger: true });
    },
    track: () => trackOptionClick('advancedCalendarViewDropdownItem'),
    isVisible: hasViewsFeature,
    testId: BoardHeaderTestIds.CalendarViewOption,
  };

  const dashboardOption = {
    name: 'dashboard',
    descriptionString: 'dashboard-view-description',
    icon: DashboardIcon,
    navigateTo: () => {
      const dashboardUrl = Controller.getBoardUrl(this.model.id, 'dashboard');
      navigate(dashboardUrl, { trigger: true });
    },
    track: () => trackOptionClick('dashboardViewDropdownItem'),
    isVisible: hasViewsFeature,
    testId: BoardHeaderTestIds.DashboardViewOption,
  };

  const tableEnabled = featureFlagClient.get(
    'panorama.single-board-table-view',
    false,
  );

  const tableOption = {
    name: 'table',
    descriptionString: 'table-view-description',
    icon: TableIcon,
    navigateTo: () => {
      const tableUrl = Controller.getBoardUrl(this.model.id, 'table');
      navigate(tableUrl, { trigger: true });
    },
    track: () => trackOptionClick('singleBoardTableView'),
    isVisible: tableEnabled && hasViewsFeature,
    isNew: true,
    testId: BoardHeaderTestIds.SingleBoardTableViewOption,
  };

  return [
    boardOption,
    mapOption,
    timelineOption,
    calendarViewOption,
    dashboardOption,
    tableOption,
  ];
};

export const removeBoardViewsButton = function () {
  if (this.$('.js-board-views-btn-container').length) {
    return ReactDOM.unmountComponentAtNode(
      this.$('.js-board-views-btn-container')[0],
    );
  }

  if (this.$('.js-board-views-switcher').length) {
    return ReactDOM.unmountComponentAtNode(
      this.$('.js-board-views-switcher')[0],
    );
  }
};

export const loadPowerUpViewsButtonOptions = async function () {
  const powerUpViewsEnabled = featureFlagClient.get(
    'ecosystem.power-up-views',
    false,
  );

  if (!powerUpViewsEnabled) {
    return;
  }

  try {
    this.isLoadingPowerUpViews = true;
    const powerUpViews = await pluginRunner.all({
      timeout: 5000,
      command: 'board-views',
      board: this.model,
    });
    this.powerUpViews = powerUpViews;
  } catch (e) {
    console.warn('Failed to request Power-Up views.');
  }

  this.isLoadingPowerUpViews = false;
  this.renderBoardViewsButton();
};

export const getPowerUpViewOptions = function () {
  if (!this.powerUpViews || this.powerUpViews.length === 0) {
    return [];
  }

  return this.powerUpViews.map((powerUpView) => ({
    ...powerUpView,
    navigateTo: () => {
      const powerUpViewUrl = Controller.getBoardUrl(this.model.id, 'power-up', [
        powerUpView.idPlugin,
        'view',
        powerUpView.key,
      ]);
      navigate(powerUpViewUrl, { trigger: true });
    },
  }));
};

export const showTimeline = function () {
  const timelineVersion = featureFlagClient.get(
    'ecosystem.timeline-version',
    'none',
  );

  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  if (timelineVersion !== 'none' && hasViewsFeature) {
    this.$('#board').addClass('hide');
    const container = this.$('.js-board-view-container')[0];
    renderComponent(
      <TimelineViewWrapper
        idBoard={this.model.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToCard={(id, params) => {
          Controller.showCardDetail(this.modelCache.get('Card', id), params);
        }}
        // eslint-disable-next-line react/jsx-no-bind
        closeView={() => {
          const boardUrl = Controller.getBoardUrl(this.model.id);
          navigate(boardUrl, { trigger: true });

          const queryString = this.model.filter.toQueryString();

          if (queryString) {
            return history.replaceState(null, null, boardUrl + queryString);
          }
        }}
      />,
      container,
    );
  } else {
    const boardUrl = Controller.getBoardUrl(this.model.id);
    navigate(boardUrl, { trigger: true });
  }
};

export const showCalendarView = function () {
  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  const canShowCalendarView = hasViewsFeature;

  if (canShowCalendarView) {
    this.$('#board').addClass('hide');
    const container = this.$('.js-board-view-container')[0];
    renderComponent(
      <SingleBoardCalendarView
        idBoard={this.model.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToCard={(id) => {
          Controller.showCardDetail(this.modelCache.get('Card', id));
        }}
        // eslint-disable-next-line react/jsx-no-bind
        closeView={() => {
          const boardUrl = Controller.getBoardUrl(this.model.id);
          navigate(boardUrl, { trigger: true, shouldTrack: false });

          const queryString = this.model.filter.toQueryString();

          if (queryString) {
            return history.replaceState(null, null, boardUrl + queryString);
          }
        }}
      />,
      container,
    );
  } else {
    const boardUrl = Controller.getBoardUrl(this.model.id);
    navigate(boardUrl, { trigger: true, shouldTrack: false });
  }
};

export const showTable = function () {
  const isTableViewEnabled = featureFlagClient.get(
    'panorama.single-board-table-view',
    false,
  );

  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  if (isTableViewEnabled && hasViewsFeature) {
    this.$('#board').addClass('hide');

    const container = this.$('.js-board-view-container')[0];
    renderComponent(
      <SingleBoardTableView
        idBoard={this.model.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToCard={(id) => {
          Controller.showCardDetail(this.modelCache.get('Card', id));
        }}
        // eslint-disable-next-line react/jsx-no-bind
        closeView={() => {
          const boardUrl = Controller.getBoardUrl(this.model.id);
          navigate(boardUrl, { trigger: true });

          const queryString = this.model.filter.toQueryString();

          if (queryString) {
            return history.replaceState(null, null, boardUrl + queryString);
          }
        }}
      />,
      container,
    );
  } else {
    const boardUrl = Controller.getBoardUrl(this.model.id);
    navigate(boardUrl, { trigger: true });
  }
};

export const closeSingleBoardView = function () {
  const viewContainer = this.$('.js-board-view-container')[0];
  ReactDOM.unmountComponentAtNode(viewContainer);
  this.$('#board').removeClass('hide');
  this.$('.js-list-name-input').trigger('autosize.resize', false);

  this.renderBoardViewsButtonDebounced();
  this.renderBritaBoardFilterButtonDebounced();
};

export const renderButlerBoardButtons = function () {
  const reactRoot = this.$('.js-butler-header-btns')[0];
  if (this.model?.editable()) {
    if (reactRoot) {
      try {
        renderComponent(
          <ButlerBoardButtons
            idBoard={this.model.id}
            idOrganization={this.model.get('idOrganization')}
          />,
          reactRoot,
        );
      } catch (err) {
        sendErrorEvent(err, {
          tags: {
            ownershipArea: 'trello-workflowers',
            feature: 'Butler on Boards',
          },
        });
      }
    }
  }
};

export const navigateToAutomaticReports = function (reportType) {
  const automaticReportView = Controller.getBoardUrl(
    this.model.id,
    `butler/reports/${reportType}`,
  );

  navigate(automaticReportView, { trigger: true });

  // Close the sidebar menu for window sizes that aren't extra large.

  if (!WindowSize.fExtraLarge) {
    this.sidebarView.hideSidebar();
  }
};

// This is actually pretty generic and just closes any overlays;
// if it ever needs reuse, feel free to rename it.
export const closeAutomaticReports = function (idBoard) {
  const boardUrl = Controller.getBoardUrl(idBoard || this.model.id);
  navigate(boardUrl, { trigger: true });
};

export const showAutomaticReports = function (reportType) {
  const idBoard = this.model.id;
  const container = this.$('.js-board-view-container')[0];
  this.$('#board').addClass('hide');

  renderComponent(
    <AutomaticReports
      reportType={reportType}
      idBoard={idBoard}
      idOrganization={this.model.get('idOrganization')}
      boardName={this.model.get('name')}
      // eslint-disable-next-line react/jsx-no-bind
      closeView={() => closeAutomaticReports(idBoard)}
    />,
    container,
  );
  Analytics.sendViewedComponentEvent({
    componentType: 'overlay',
    componentName: 'butlerReportBuilderOverlay',
    source: 'butlerReportBuilderOverlay',
    attributes: {
      reportType,
    },
  });
};

// There are many things that could cause the filter count to change
const watchedEvents = [
  // We could learn about a new card that matches the filter
  'add:Card',
  // A card that matched the filter may have been deleted
  'remove:Card',
  // A card may change so that it is no a match (or isn't one anymore)
  'change:Card',
  // We could learn about a new list that has matches in it (e.g. a list may have been moved to this board)
  'add:List',
  // A list that had matches in it could have been moved off of the board
  'remove:List',
  // A list with matches could have been closed or re-opened
  'change:List',
].join(' ');

export const initializeFilterCountMonitoring = function () {
  let isMonitoring = false;
  const updateCount = this.frameDebounce(() => {
    const boardCardCount = this.model.filter.isFiltering()
      ? this.model
          .openCards()
          .filter((card) => this.model.filter.satisfiesFilter(card)).length
      : 0;

    // Keep the filtered cards count for the board in sync with a shared state,
    // to avoid an unnecessary API call for SBVs. If this gets migrated to GraphQL
    // and we have the data in cache, we can eventually deprecate this.
    if (boardCardCount !== filteredCardsCountState.value.count) {
      filteredCardsCountState.setValue({ count: boardCardCount });
    }
  });

  const updateMonitoring = () => {
    const isFiltering = this.model.filter.isFiltering();
    if (isFiltering) {
      if (!isMonitoring) {
        isMonitoring = true;
        // Listen for all of the watched events that happen in the ModelCache, including
        // (possibly) events related to other boards.  Some of the events won't affect the
        // count (e.g. if a card changes position, or we got an update about a card on another
        // board) but counting the cards isn't too expensive if we're debouncing it
        this.listenTo(this.modelCache, watchedEvents, updateCount);
      }
      // The filter changed, so the count may be different
      updateCount();
    } else if (!isFiltering && isMonitoring) {
      isMonitoring = false;
      this.stopListening(this.modelCache, watchedEvents, updateCount);
    }
  };

  // Only monitor the model cache if we're currently filtering
  this.listenTo(this.model.filter, 'change', updateMonitoring);
  updateMonitoring();
};
